export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Share testing progress, blockers, and test results', time: '9:00 AM daily' },
      { name: 'Test Case Review', description: 'Review and update test cases based on requirements', requirement: 'All test cases reviewed before execution' },
      { name: 'Bug Verification', description: 'Verify bug fixes and regression testing', coverage: 'All reported bugs must be verified' }
    ],
    responsibilities: [
      { area: 'Manual Testing', tasks: ['Execute test cases', 'Report bugs with detailed steps', 'Verify bug fixes', 'Update test documentation'] },
      { area: 'Test Documentation', tasks: ['Create test cases', 'Maintain test data', 'Document test results', 'Update test procedures'] },
      { area: 'Regression Testing', tasks: ['Execute regression test suites', 'Identify test scope', 'Report regression issues', 'Maintain test coverage'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Plan testing activities' },
      { name: 'Test Review', frequency: 'Weekly', duration: '1 hour', role: 'Review test cases and results' },
      { name: 'Bug Triage', frequency: 'Bi-weekly', duration: '1 hour', role: 'Participate in bug prioritization' }
    ]
  },
  mid: {
    processes: [
      { name: 'Test Strategy Planning', description: 'Contribute to test strategy and automation planning', frequency: 'Weekly' },
      { name: 'Automation Development', description: 'Develop and maintain test automation frameworks', responsibility: 'Lead automation initiatives' },
      { name: 'Performance Testing', description: 'Design and execute performance test scenarios', scope: 'Application performance validation' }
    ],
    responsibilities: [
      { area: 'Test Automation', tasks: ['Design automation frameworks', 'Develop automated test scripts', 'Maintain test automation', 'Integrate with CI/CD'] },
      { area: 'Test Leadership', tasks: ['Mentor junior testers', 'Lead test planning', 'Review test strategies', 'Coordinate testing activities'] },
      { area: 'Quality Analysis', tasks: ['Analyze test metrics', 'Identify quality trends', 'Recommend improvements', 'Report quality status'] }
    ],
    ceremonies: [
      { name: 'Test Strategy Review', frequency: 'Weekly', duration: '2 hours', role: 'Lead test strategy discussions' },
      { name: 'Automation Planning', frequency: 'Bi-weekly', duration: '1 hour', role: 'Plan automation roadmap' },
      { name: 'Quality Review', frequency: 'Monthly', duration: '2 hours', role: 'Analyze quality metrics' }
    ]
  },
  senior: {
    processes: [
      { name: 'Quality Strategy', description: 'Define overall quality strategy and standards', scope: 'Organization-wide quality leadership' },
      { name: 'Process Improvement', description: 'Lead quality process improvements and best practices', impact: 'Quality culture transformation' },
      { name: 'Risk Management', description: 'Assess and manage quality risks across products', responsibility: 'Quality risk ownership' }
    ],
    responsibilities: [
      { area: 'Quality Leadership', tasks: ['Define quality vision', 'Establish quality standards', 'Lead quality initiatives', 'Drive quality culture'] },
      { area: 'Strategic Planning', tasks: ['Develop quality roadmap', 'Evaluate quality tools', 'Plan quality investments', 'Align with business goals'] },
      { area: 'Team Development', tasks: ['Build QA teams', 'Develop QA capabilities', 'Mentor QA leaders', 'Foster quality mindset'] }
    ],
    ceremonies: [
      { name: 'Quality Leadership', frequency: 'Weekly', duration: '3 hours', role: 'Quality strategy leadership' },
      { name: 'Executive Reporting', frequency: 'Monthly', duration: '2 hours', role: 'Quality status to executives' },
      { name: 'Industry Engagement', frequency: 'Quarterly', duration: '4 hours', role: 'Quality community leadership' }
    ]
  }
};
